module.exports = __webpack_public_path__ + "static/media/radiopublic-flag-red.148323e7.svg";